var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OrderItem, Store } from 'aigens-ng-core';
import { MobileBasePage } from '../../../core/base/mobile-base-page';
import { Injector, OnInit } from '@angular/core';
import { SurveyDialog } from '../../../dialogs/survey/survey';
import { currentTimeString, timeStringLabel } from '../../../shared/utilities/checkFormatTool';
import { preloaderFinished } from '../../../../preloader';
var ByodSummaryPage = /** @class */ (function (_super) {
    __extends(ByodSummaryPage, _super);
    function ByodSummaryPage(injector) {
        var _this = _super.call(this, injector) || this;
        _this.ordersMap = {};
        _this.listExpand = {};
        _this.firstTime = true;
        _this.hasProblem = false;
        _this.printerDisconnect = false;
        _this.listening = false;
        _this.hiddenGrandTotal = false;
        _this.printerStatus = {};
        _this.orderStatusDisplayMap = {};
        _this.showSurveyBox = true;
        _this.isPrinterOffline = false;
        _this.loadingTime = currentTimeString();
        _this.session = _this.getNavParams('sessionId');
        _this.isIsolate = _this.getNavParams('isIsolate');
        console.log('this.isIsolate', _this.isIsolate);
        _this.hiddenGrandTotal = _this.orderService.hideTotal;
        if (!_this.session) {
            _this.session = _this.orderService.session;
        }
        else if (!_this.orderService.session) {
            _this.orderService.session = _this.session;
        }
        var host = window.location.host;
        if (host === 'bksg.order.place') {
            _this.orderService.isBK = true;
        }
        if (_this.orderService.isBK && !_this.session) {
            _this.session = '1234';
        }
        if (!_this.orderService.surveyUrl) {
            _this.showSurveyBox = false;
        }
        if (_this.orderService.store) {
            var store = _this.orderService.store;
            try {
                if (store.brand && store.brand['config'] && store.brand['config'][0] && store.brand['config'][0]['general']) {
                    _this.orderStatusDisplayMap = store.brand['config'][0]['general'];
                }
            }
            catch (error) {
                console.error("error in store.brand[\"config\"][0][\"general\"];");
            }
        }
        _this.addInfo = Store.getPickUpInfo(_this.orderManager.store);
        window.history.replaceState({}, 'Order.Place', _this.navigationService.getRootPageUrl());
        return _this;
    }
    ByodSummaryPage.getPageUrl = function () {
        return 'byod-summary';
    };
    ByodSummaryPage.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        if (this.browserService.isBKApp()) {
            console.log('exit webview');
            genkiJSInterface.exitwebview();
        }
        if (!this.orders) {
            this.getOrders();
        }
        console.log('surveyExtBrowser', this.orderService.surveyExtBrowser);
    };
    ByodSummaryPage.prototype.ionViewWillLeave = function () {
        _super.prototype.ionViewWillLeave.call(this);
        this.monitoringService.unlistenAll();
    };
    ByodSummaryPage.prototype.getOrders = function (refresher) {
        var _this = this;
        if (this.isCalledIn(5000)) {
            this.loading(false);
            if (refresher) {
                refresher.complete();
            }
            return;
        }
        var spot = this.orderService.spot;
        var storeId = this.orderService.storeId;
        var deviceId = this.sessionService.getDeviceId();
        var mode = this.orderManager.mode;
        var session = this.orderService.session;
        if (!storeId) {
            storeId = this.getNavParams('store');
            this.orderService.storeId = storeId;
        }
        if (!spot) {
            spot = this.getNavParams('spot');
            this.orderService.spot = spot;
        }
        if (!mode) {
            mode = this.getNavParams('mode');
            this.orderManager.mode = mode;
        }
        if (!session) {
            session = this.getNavParams('key');
            if (!session) {
                session = this.getNavParams('session');
            }
            this.orderService.session = session && session !== '0' ? session : null;
        }
        this.orderService.deviceId = this.sessionService.getDeviceId();
        if (!this.orderService.session && !this.orderService.preOrder && this.orderService.storeId) {
            var paid = true; // force to true for getting session
            this.genSetSession(this.orderService.storeId.toString(), paid ? function () {
                _this.getOrderFlow(_this.orderService.spot, _this.orderService.storeId, _this.orderManager.mode, _this.orderService.deviceId, refresher);
            } : null);
        }
        else {
            this.getOrderFlow(this.orderService.spot, this.orderService.storeId, this.orderManager.mode, this.orderService.deviceId, refresher);
        }
    };
    ByodSummaryPage.prototype.getOrderFlow = function (spot, storeId, mode, deviceId, refresher) {
        var _this = this;
        if (refresher === void 0) { refresher = null; }
        if (this.orderService.isBK) {
            this.orderService.getBKOrders(this.session).subscribe(function (orders) {
                if (refresher) {
                    refresher.complete();
                }
                _this.loadingTime = currentTimeString();
                _this.orders = _this.orderService.isBK ? orders : _this.sortingOrder(orders);
                console.log(orders);
                if (_this.orders) {
                    _this.orders.forEach(function (order) {
                        if (_this.listExpand[order.id] === null) {
                            _this.listExpand[order.id] = false;
                        }
                        if (order.orderitems) {
                            order.orderitems.forEach(function (oi) {
                                OrderItem.flattenItems(oi);
                            });
                        }
                        if (order.pickup) {
                            order['pickupTimeLabel'] = timeStringLabel(order.pickup);
                        }
                        /*if (order["deliveryTime"]){
                            order["deliveryTimeLabel"] = order["deliveryTime"].replace("T"," ").replace(":00.000","");
                        }*/
                        /*if (order["address"]) {
                            order["addressString"] = this.getAddressString(order);
                        }*/
                    });
                    if (_this.orders.length === 1) {
                        _this.listExpand[orders[0].id] = true;
                    }
                }
                _this.loading(false);
            }, function (err) {
                _this.loading(false);
                if (refresher) {
                    refresher.complete();
                }
                else {
                    _this.showError(err);
                }
                _this.loadingTime = currentTimeString();
                console.log(err);
            }, function () {
                _this.loading(false);
                preloaderFinished();
            });
        }
        else if (this.isIsolate) {
            this.loading(true);
            this.orderService.getOrders(this.session).subscribe(function (orders) {
                if (refresher) {
                    refresher.complete();
                }
                _this.loadingTime = currentTimeString();
                _this.loading(false);
                _this.orders = orders;
                _this.orders.sort(function (a, b) {
                    if (a.create < b.create) {
                        return 1;
                    }
                    if (a.create > b.create) {
                        return -1;
                    }
                    return 0;
                });
                console.log(orders);
                if (_this.orders) {
                    // listen to firebase
                    _this.handleFirebaseOrderStatus();
                    var hasSendingOrder_1 = false;
                    _this.orders.forEach(function (order) {
                        // console.log('this.oreder[i] ###',order);
                        // add a local flag to control ui css
                        if (order.type === 'delivery') {
                            order['stayStatusIndex'] = _this.getStayIndex(order);
                        }
                        if (order.orderitems) {
                            order.orderitems.forEach(function (oi) {
                                // oi.makeFlatItems();
                                OrderItem.flattenItems(oi);
                            });
                            order.orderitems = order.orderitems.reverse();
                            _this.patchTime(order.orderitems);
                        }
                        _this.ordersMap[order.id] = order;
                        if (_this.listExpand[order.id] === null) {
                            // ???
                            _this.listExpand[order.id] = false;
                        }
                        // if(this.orderService.store && (this.orderService.store.id === 5669108628586496 || this.orderService.store.id === 5143146715414528)){
                        if (order.status === 'sending' && !_this.listening) {
                            _this.listening = true;
                            hasSendingOrder_1 = true;
                            _this.monitoringService.listenStoreStarPrintStatus(_this.orderService.storeId, function (result) {
                                // var status = result["status"]["status"];
                                if (result) {
                                    if (result['status']) {
                                        _this.printerStatus[result['ip']] = result['status'];
                                    }
                                    else {
                                        for (var key in result) {
                                            _this.printerStatus[result[key]['ip']] = result[key]['status'];
                                            _this.listenOrder(result[key]['ip'], order);
                                        }
                                    }
                                    _this.isStarPrinterOffline();
                                }
                            });
                        }
                        else if (order.status === 'sending') {
                            hasSendingOrder_1 = true;
                        }
                        // }
                    });
                    // if(this.orderService.store && (this.orderService.store.id === 5669108628586496 || this.orderService.store.id === 5143146715414528)){
                    if (!hasSendingOrder_1 && _this.listening) {
                        _this.stopListenPrinter();
                    }
                    _this.isStarPrinterOffline();
                    // }
                    if (_this.orders.length > 0) {
                        _this.listExpand[orders[0].id] = true;
                        _this.orders[0].storeId;
                        _this.systemConfigService.getSystemConfig(_this.orders[0].storeId, function (data) {
                            console.log('data', data);
                            _this.themeService.setConfigTheme(data['data'] ? data['data']['colors'] : null);
                        });
                    }
                    else {
                        _this.themeService.setConfigTheme({ dummy: true });
                    }
                }
            }, function (err) {
                if (refresher) {
                    refresher.complete();
                }
                _this.loadingTime = currentTimeString();
                console.log(err);
                _this.showError(err);
                _this.loading(false);
            }, function () {
                if (refresher) {
                    refresher.complete();
                }
                preloaderFinished();
                _this.loadingTime = currentTimeString();
                _this.loading(false);
            });
        }
        else {
            if (this.firstTime) {
                this.firstTime = false;
                this.loading(true);
            }
            this.orderService.getByodOrders(storeId, spot, deviceId).subscribe(function (orders) {
                if (refresher) {
                    refresher.complete();
                }
                _this.loadingTime = currentTimeString();
                _this.loading(false);
                _this.orders = orders;
                _this.orders.sort(function (a, b) {
                    if (a.create < b.create) {
                        return 1;
                    }
                    if (a.create > b.create) {
                        return -1;
                    }
                    return 0;
                });
                console.log(orders);
                if (_this.orders) {
                    // listen to firebase
                    _this.handleFirebaseOrderStatus();
                    var hasSendingOrder_2 = false;
                    _this.orders.forEach(function (order) {
                        // console.log('this.oreder[i] ###',order);
                        // add a local flag to control ui css
                        if (order.type === 'delivery') {
                            order['stayStatusIndex'] = _this.getStayIndex(order);
                        }
                        if (order.orderitems) {
                            order.orderitems.forEach(function (oi) {
                                // oi.makeFlatItems();
                                OrderItem.flattenItems(oi);
                            });
                            order.orderitems = order.orderitems.reverse();
                            _this.patchTime(order.orderitems);
                        }
                        _this.ordersMap[order.id] = order;
                        if (_this.listExpand[order.id] === null) {
                            // ???
                            _this.listExpand[order.id] = false;
                        }
                        // if(this.orderService.store && (this.orderService.store.id === 5669108628586496 || this.orderService.store.id === 5143146715414528)){
                        if (order.status === 'sending' && !_this.listening) {
                            _this.listening = true;
                            hasSendingOrder_2 = true;
                            _this.monitoringService.listenStoreStarPrintStatus(_this.orderService.storeId, function (result) {
                                // var status = result["status"]["status"];
                                if (result) {
                                    if (result['status']) {
                                        _this.printerStatus[result['ip']] = result['status'];
                                    }
                                    else {
                                        for (var key in result) {
                                            _this.printerStatus[result[key]['ip']] = result[key]['status'];
                                            _this.listenOrder(result[key]['ip'], order);
                                        }
                                    }
                                    _this.isStarPrinterOffline();
                                }
                            });
                        }
                        else if (order.status === 'sending') {
                            hasSendingOrder_2 = true;
                        }
                        // }
                    });
                    // if(this.orderService.store && (this.orderService.store.id === 5669108628586496 || this.orderService.store.id === 5143146715414528)){
                    if (!hasSendingOrder_2 && _this.listening) {
                        _this.stopListenPrinter();
                    }
                    _this.isStarPrinterOffline();
                    // }
                    if (_this.orders.length > 0) {
                        _this.listExpand[orders[0].id] = true;
                    }
                }
            }, function (err) {
                if (refresher) {
                    refresher.complete();
                }
                _this.loadingTime = currentTimeString();
                console.log(err);
                _this.showError(err);
                _this.loading(false);
            }, function () {
                if (refresher) {
                    refresher.complete();
                }
                preloaderFinished();
                _this.loadingTime = currentTimeString();
                _this.loading(false);
            });
        }
    };
    // todo adjust the return-val accoding the case
    ByodSummaryPage.prototype.getStayIndex = function (order) {
        if (order && order['deliveryStatus']) {
            var status_1 = order['deliveryStatus'];
            switch (status_1) {
                case 'pending':
                    return 0;
                case 'paying':
                    return 0;
                case 'accepted':
                    return 1;
                case 'rejected':
                    return 0;
                case 'allocated':
                    return 1;
                case 'picked':
                    return 2;
                case 'arrived':
                    return 3;
                case 'delivered':
                    return 3;
                case 'cancelled':
                    return 0;
                case 'failed':
                    return 0;
            }
        }
        else {
            return 0;
        }
    };
    ByodSummaryPage.prototype.handleFirebaseOrderStatus = function () {
        var _this = this;
        var str = null;
        var _loop_1 = function (order) {
            if (order && order['statusUrl']) {
                str = order['statusUrl'].toString();
                // prd aigensstoreapp.firebaseapp.com
                var indexOfUpdate = str.indexOf('update');
                var res = str.slice(indexOfUpdate, str.length - 5);
                // let lastIndex = res.lastIndexOf('/');
                // var res2 = res.slice(0, lastIndex + 1);
                // console.log('resres', res2);
                if (order && str) {
                    this_1.monitoringService.listenOrderStatus2(res, function (current) {
                    }, function (update) {
                        console.log('update detected', update);
                        if (update) {
                            order.status = update['status'];
                            if (order.type === 'delivery') {
                                console.log('delivery listenOrder data.deliveryStatus:', update['deliveryStatus']);
                                order['deliveryStatus'] = update['deliveryStatus'];
                                order['stayStatusIndex'] = _this.getStayIndex(order);
                                // console.log('this.orders',this.orders);
                            }
                        }
                    }, function () {
                    });
                }
            }
        };
        var this_1 = this;
        for (var _i = 0, _a = this.orders; _i < _a.length; _i++) {
            var order = _a[_i];
            _loop_1(order);
        }
        // flag control
        if (this.systemConfigService.showOrderQueue) {
            this.checkFirebaseStoreOrders();
        }
    };
    // flag control
    ByodSummaryPage.prototype.checkFirebaseStoreOrders = function () {
        var _this = this;
        if (this.orders && this.orders.length > 0) {
            var order = this.orders[0];
            var str = order['statusUrl'].toString();
            // prd aigensstoreapp.firebaseapp.com
            var indexOfUpdate = str.indexOf('update');
            var res = str.slice(indexOfUpdate, str.length - 5);
            var lastIndex = res.lastIndexOf('/');
            var res2 = res.slice(0, lastIndex);
            console.log('resres', res2);
            if (order && res2) {
                this.monitoringService.listenStoreOrder(res2, function (current) {
                    // console.log("orders first view detected",current);
                    var storeOrders = current;
                    for (var _i = 0, _a = _this.orders; _i < _a.length; _i++) {
                        var o = _a[_i];
                        // reset all
                        o['orderQueue'] = 0;
                        for (var sOrderId in storeOrders) {
                            if (o.create > storeOrders[sOrderId].create && storeOrders[sOrderId].status === 'received') {
                                if (o['orderQueue']) {
                                    o['orderQueue'] += 1;
                                }
                                else {
                                    o['orderQueue'] = 1;
                                }
                            }
                        }
                    }
                }, function (update) {
                    // console.log("orders update detected", update);
                    // if (update) {
                    //     for (let order of this.orders) {
                    //         if(update.create < order.create && update.status != 'received')
                    //         {
                    //             if(order['orderQueue'])
                    //             {
                    //                 order['orderQueue'] -= 1;
                    //             }
                    //         }
                    //     }
                    // }
                }, function (del) {
                    // console.log("orders del detected",del);
                });
            }
        }
    };
    ByodSummaryPage.prototype.listenOrders = function (printAddress) {
        var _this = this;
        if (printAddress && this.orders) {
            this.orders.forEach(function (order) {
                if (order.status === 'sending' && !_this.monitoringService.isOrderMonitoring(order.orderNo)) {
                    _this.monitoringService.listenPrinterOrder(printAddress, order.orderNo, function (data) {
                        console.log('changed');
                        console.log(data);
                        if (data.value) {
                            _this.firebaseAssignValue(order.id, data.type, data.value);
                        }
                        else {
                            var result = data.type === 'status' ? 'completed' : null;
                            _this.firebaseAssignValue(order.id, data.type, result);
                            if (result) {
                                _this.monitoringService.unlistenOrderPair(order.orderNo, function () {
                                    if (_this.monitoringService.numberOfRefs <= 1) {
                                        _this.stopListenPrinter();
                                    }
                                });
                            }
                        }
                    });
                }
            });
        }
    };
    ByodSummaryPage.prototype.getOrderStatusDisplay = function (order) {
        var lang = this.t.currentLang;
        var statusDisplay = '';
        if (lang.startsWith('zh')) {
            if (this.orderStatusDisplayMap && this.orderStatusDisplayMap[order.status] && this.orderStatusDisplayMap[order.status]['nameZh'] &&
                this.orderStatusDisplayMap[order.status]['nameZh'] !== '') {
                statusDisplay = this.orderStatusDisplayMap[order.status]['nameZh'];
                return statusDisplay;
            }
            else {
                var translateWord = 'status.' + order.type + '.' + order.status;
                statusDisplay = this.t.instant(translateWord);
                return statusDisplay;
            }
        }
        else if (lang === 'en') {
            if (this.orderStatusDisplayMap && this.orderStatusDisplayMap[order.status] && this.orderStatusDisplayMap[order.status]['nameEn'] &&
                this.orderStatusDisplayMap[order.status]['nameEn'] !== '') {
                statusDisplay = this.orderStatusDisplayMap[order.status]['nameEn'];
                return statusDisplay;
            }
            else {
                var translateWord = 'status.' + order.type + '.' + order.status;
                statusDisplay = this.t.instant(translateWord);
                return statusDisplay;
            }
        }
        else {
            var translateWord = 'status.' + order.type + '.' + order.status;
            statusDisplay = this.t.instant(translateWord);
            return statusDisplay;
        }
    };
    ByodSummaryPage.prototype.listenOrder = function (printAddress, order) {
        var _this = this;
        if (printAddress && order) {
            if (!this.monitoringService.isOrderMonitoring(order.orderNo)) {
                this.monitoringService.listenPrinterOrder(printAddress, order.orderNo, function (data) {
                    console.log('changed');
                    console.log(data);
                    if (data.value) {
                        _this.firebaseAssignValue(order.id, data.type, data.value);
                    }
                    else {
                        var result = data.type === 'status' ? 'completed' : null;
                        _this.firebaseAssignValue(order.id, data.type, result);
                        if (result && order.type !== 'delivery') {
                            _this.monitoringService.unlistenOrderPair(order.orderNo, function () {
                                if (_this.monitoringService.numberOfRefs <= 1) {
                                    _this.stopListenPrinter();
                                }
                            });
                        }
                    }
                });
            }
        }
    };
    ByodSummaryPage.prototype.firebaseAssignValue = function (id, type, value) {
        if (type === 'status') {
            this.ordersMap[id].status = value;
        }
        else {
            this.ordersMap[id].error = value;
        }
    };
    ByodSummaryPage.prototype.stopListenPrinter = function () {
        this.listening = false;
        console.log('stop listen1', this.hasProblem);
        this.hasProblem = false;
        console.log('stop listen2', this.hasProblem);
        this.printerStatus = {};
        this.monitoringService.unlistenAll();
    };
    ByodSummaryPage.prototype.patchTime = function (orderitems) {
        var lastTime = null;
        for (var _i = 0, orderitems_1 = orderitems; _i < orderitems_1.length; _i++) {
            var oi = orderitems_1[_i];
            var thisTime = oi.create;
            if (thisTime === lastTime) {
                oi.create = null;
            }
            lastTime = thisTime;
        }
    };
    ByodSummaryPage.prototype.orderClicked = function (order) {
        console.log('this.order', order);
        if (order.payment === 'cash' && order.status !== 'pending' && order.status !== 'paying') {
            console.log('order.status', order.status);
            return;
        }
        if (order.type === 'prekiosk' && order.status !== 'paid' && order.status !== 'cancelled') {
            this.pushByName('OrderStatusPreKioskPage', { qrData: order['id'], order: order, ifSessionId: false });
            // this.navController.push(OrderStatusPreKioskPage, { order: order });
        }
        else if (order.payments && order.payments.length > 0) {
            // TODO: unify qrcode handlment with base cart page
            if (order.payments[0].type === 'cash') {
                if (order.payments[0].gateway === 'delaypayment') {
                    var qrdata = (order && order['extra'] && order['extra']['posBackendId']);
                    if (qrdata) {
                        qrdata = 'TMPOR' + qrdata;
                    }
                    // this.navController.push(OrderQrCodePage, { qrData: qrdata, ifSessionId: false });
                    this.pushByName('QrCodePage', { qrData: qrdata, order: order, ifSessionId: false });
                }
                else if (order.payments[0].gateway === 'cash' || order.payments[0].gateway === 'pos') {
                    // this.navController.push(OrderQrCodePage, { qrData: order.id, ifSessionId: false });
                    this.pushByName('QrCodePage', { qrData: order['id'], order: order, ifSessionId: false, goBackUrl: 'byod-summary' });
                }
            }
            else if (order.payments[0].type === 'delay') {
                var qrdata = (order && order['qrcode']);
                this.pushByName('QrCodePage', { qrData: qrdata, order: order, ifSessionId: false });
                // this.navController.push(OrderQrCodePage, { qrData: qrdata, ifSessionId: false });
            }
        }
    };
    // payCashClicked(order) {
    //     console.log('payCashClicked:', order);
    //     this.pushByName('QrCodePage', { qrData: order['id'], ifSessionId: false, goBackUrl: 'byod-summary' }, ).then(() => {
    //         this.orderService.clear();
    //         if (this.navParams.get('fromSplash')) {
    //             this.orderManager.clear();
    //         }
    //     });
    // }
    ByodSummaryPage.prototype.isStarPrinterOffline = function () {
        if (Object.keys(this.printerStatus).length > 0 && this.listening) {
            var noProblem = true;
            var disconnect = false;
            var currentTime = new Date().getTime();
            for (var key in this.printerStatus) {
                if (this.printerStatus[key]['status'] === 'offline') {
                    noProblem = false;
                    break;
                }
                noProblem = true;
            }
            for (var key in this.printerStatus) {
                if (currentTime - this.printerStatus[key]['datetime'] > 2.5 * 60000) {
                    noProblem = false;
                    disconnect = true;
                    break;
                }
                disconnect = false;
            }
            this.printerDisconnect = disconnect;
            console.log('1is Offline?', this.isPrinterOffline);
            this.isPrinterOffline = !noProblem;
            console.log('2is Offline?', this.isPrinterOffline);
            return this.isPrinterOffline;
        }
    };
    ByodSummaryPage.prototype.doRefresh = function (refresher, isRefreshButton) {
        if (isRefreshButton === void 0) { isRefreshButton = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    ByodSummaryPage.prototype.getUIRefreshInterval = function () {
        // if(this.orderService.store && this.orderService.store.id === 5669108628586496){
        //     return 0;
        // }else{
        return 10000;
        // return 0;
        // }
    };
    ByodSummaryPage.prototype.onRefreshUI = function () {
        console.log('refresh ui');
        if (this.orders && this.orders.length > 0 && this.orders[0].type && this.orders[0].type !== 'byod') {
            this.doRefresh();
        }
    };
    // TO-DO expand only that list
    ByodSummaryPage.prototype.clickToExpand = function (index) {
        this.listExpand[index] = !this.listExpand[index];
    };
    ByodSummaryPage.prototype.getAddressString = function (order) {
        var addressString;
        for (var key in order['address']) {
            if (order['address'][key]) {
                addressString = addressString === null ? order['address'][key] : (addressString + ',' + order['address'][key]);
            }
        }
        return addressString;
    };
    ByodSummaryPage.prototype.sortingOrder = function (orders) {
        var tmp = [];
        var pending = [];
        var ready = [];
        var received = [];
        var paid = [];
        var completed = [];
        orders.forEach(function (order) {
            if (order.status === 'ready') {
                ready.push(order);
            }
            else if (order.status === 'ready') {
                ready.push(order);
            }
            else if (order.status === 'received') {
                received.push(order);
            }
            else if (order.status === 'paid') {
                paid.push(order);
            }
            else if (order.status === 'completed') {
                completed.push(order);
            }
        });
        if (pending.length > 0) {
            tmp = tmp.concat(pending);
        }
        if (ready.length > 0) {
            tmp = tmp.concat(ready);
        }
        if (received.length > 0) {
            tmp = tmp.concat(received);
        }
        if (paid.length > 0) {
            tmp = tmp.concat(paid);
        }
        if (completed.length > 0) {
            tmp = tmp.concat(completed);
        }
        return tmp;
    };
    ByodSummaryPage.prototype.isSet = function (oi) {
        return OrderItem.isSet(oi);
    };
    ByodSummaryPage.prototype.discloseSurvey = function () {
        this.showSurveyBox = false;
    };
    ByodSummaryPage.prototype.createSurvey = function () {
        return __awaiter(this, void 0, void 0, function () {
            var input, modal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('created');
                        input = { store: this.orderManager.store };
                        return [4 /*yield*/, this.modalController.create({
                                component: SurveyDialog,
                                componentProps: input,
                                showBackdrop: true,
                                backdropDismiss: true,
                                cssClass: 'no-bgColor'
                            })];
                    case 1:
                        modal = _a.sent();
                        modal.present();
                        this.showSurveyBox = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ByodSummaryPage.prototype.pageName = function () {
        return '/byod-summary';
    };
    return ByodSummaryPage;
}(MobileBasePage));
export { ByodSummaryPage };
